<template>
  <el-table :data="productGroupOrders" border style="width: 100%" class="table">
    <el-table-column prop="orderId" :label="$t('productGroupOrderManage.orderId')" align="center"
      width="120"></el-table-column>
    <el-table-column :label="$t('productGroupOrderManage.productImage')" align="center" width="100">
      <template slot-scope="scope">
        <el-image style="width: 50px; height: 50px; border-radius: 10px;"
          :src="scope.row.coverPhoto || '/img/noPhoto.jpg'" fit="cover"></el-image>
      </template>
    </el-table-column>
    <el-table-column :label="$t('productGroupOrderManage.productName')" align="center">
      <template slot-scope="scope">
        【{{ scope.row.userCount }}人团】{{ scope.row.prodName }}
      </template>
    </el-table-column>
    <el-table-column prop="buyerName" :label="$t('productGroupOrderManage.buyer')" align="center"></el-table-column>
    <el-table-column prop="groupBuyerName" :label="$t('productGroupOrderManage.groupLeader')"
      align="center"></el-table-column>
    <el-table-column prop="buyerCount" :label="$t('productGroupOrderManage.purchaseQuantity')"
      align="center"></el-table-column>
    <el-table-column :label="$t('productGroupOrderManage.groupSize')" align="center">
      <template slot-scope="scope">
        {{ scope.row.groupCount }}/{{ scope.row.userCount }}
      </template>
    </el-table-column>
    <el-table-column prop="groupPrice" :label="$t('productGroupOrderManage.groupAmount')"
      align="center"></el-table-column>
    <el-table-column prop="stateName" :label="$t('productGroupOrderManage.status')" align="center"></el-table-column>
    <el-table-column prop="rebateAmount" :label="$t('productGroupOrderManage.rebateAmount')"
      align="center"></el-table-column>
    <el-table-column prop="openTime" :label="$t('productGroupOrderManage.openTime')" align="center"
      width="150"></el-table-column>
    <el-table-column prop="createTime" :label="$t('productGroupOrderManage.groupTime')" align="center"
      width="150"></el-table-column>
    <el-table-column prop="endTime" :label="$t('productGroupOrderManage.deadline')" align="center"
      width="150"></el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ProductGroupOrderTable',
  props: {
    productGroupOrders: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>